import { InputClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiInput: Record<InputClassKey, CSSProperties> = {
  root: {},
  underline: { '&.Mui-disabled:before': { borderBottomStyle: 'solid' } },
  colorSecondary: {},
  disabled: {},
  error: {},
  focused: {},
  formControl: {},
  fullWidth: {},
  input: {},
  inputMarginDense: {},
  inputMultiline: {},
  inputTypeSearch: {},
  marginDense: {},
  multiline: {},
};
